import { TrackingEvent } from 'client/tracking/event';
import { CommonMap } from 'client/tracking/maps/common';
import { TrackingConstant } from 'client/tracking/constant';
import { TrackingHelper } from './tracking-helper';

function getOverrides(options) {
  return TrackingHelper.getBasicDealerOptions(options);
}

const map = {
  dealer_review_submit: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_WRITE_REVIEW,
    TrackingConstant.SUBMIT_REVIEW
  ),
  dealer_review_comment_submit: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_WRITE_REVIEW,
    TrackingConstant.SUBMIT_COMMENT
  ),
  ddp_view_dealer_hours(options) {
    return TrackingEvent.actionCompleted(
      TrackingConstant.ACTION_DEALER_ENGAGEMENT,
      TrackingConstant.VIEW_DEALER_HOURS,
      getOverrides(options)
    );
  },
  ddp_call_dealer(options) {
    return TrackingEvent.actionCompleted(
      TrackingConstant.ACTION_DEALER_ENGAGEMENT,
      TrackingConstant.CALL_DEALER,
      getOverrides(options)
    );
  },
  dealer_engagement_text: TrackingEvent.actionStart(
    TrackingConstant.ACTION_DEALER_ENGAGEMENT,
    TrackingConstant.TEXT_DEALER
  ),
};

export const TrackingMap = {
  ...CommonMap,
  ...map,
};
